<header fxLayout="row nowrap" fxLayoutAlign="space-around center">
    <mat-icon (click)="setActiveLang()">language</mat-icon>
    <a routerLink="home" routerLinkActive="active">
        {{ 'header.home' | transloco }}
    </a>
    <a routerLink="references" routerLinkActive="active">
        {{ 'header.references' | transloco }}
    </a>
    <a routerLink="equipment" routerLinkActive="active">
        {{ 'header.equipment' | transloco }}
    </a>
    <a routerLink="contact" routerLinkActive="active">
        {{ 'header.contact' | transloco }}
    </a>
    <a routerLink="imprint" routerLinkActive="active">
        {{ 'header.imprint' | transloco }}
    </a>
</header>
